import at from '../actionTypes'
import createReducer from './utilities/createReducer'
import serverTimestamp from '../../utilities/Data/serverTimestamp'

const fixTimeStamps = post => ({
	createdTimestamp: serverTimestamp(post.createdTimestamp),
	modifiedTimestamp: serverTimestamp(post.modifiedTimestamp)
})

export default createReducer({}, {
	[at.feedFetch_Success]: (state, action) => ({
		...state,
		feed: action.payload.feed.map(post => ({
			...post,
			tags: [...post.tags],
			...fixTimeStamps(post)
		}))
	})
})



// WEBPACK FOOTER //
// ./src/redux/reducers/feedReducer.js